import {
  FETCH_MAINTENANCE_LIST,
  FETCH_MAINTENANCE_STATUS_LIST,
  FETCH_MAINTENANCE_TYPE,
  ADD_MAINTENANCE,
  DELETE_MAINTENANCE,
  CHANGE_MAINTENANCE_STATUS,
  ASSIGN_MANINTENANCE,
  FETCH_ASSET_CLIENT_LIST,
  DELETE_PO,
  DELETE_ASSET_CHECKLIST,
  MARK_CHECKLIST_COMPLETE,
  ADD_ASSET_CHECKLIST,
  FETCH_MAINTENANCE_BY_ID,
  UPDATE_MAINTENANCE,
  ADD_COMMENT,
  FETCH_WORK_ORDERS,
  ADD_WORK_ORDERS,
  UPDATE_WORK_ORDER,
} from "../constants/type";

const initialState = {
  maintenanceDetail: {},
  statusList: [],
  maintenanceType: [],
  maintenanceList: [],
  clientList: [],
  workOrders: [],
  workOrderCount: 0,
  workOrderDetails: {},
  nextWorkIdRes: {},
};

const maintenanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MAINTENANCE_LIST:
      return {
        ...state,
        maintenanceList: action.data,
      };
    case FETCH_ASSET_CLIENT_LIST:
      return {
        ...state,
        clientList: action.data,
      };
    case FETCH_MAINTENANCE_STATUS_LIST:
      return {
        ...state,
        statusList: action.data,
      };
    case FETCH_MAINTENANCE_TYPE:
      return {
        ...state,
        maintenanceType: action.data,
      };
    case ADD_MAINTENANCE:
      return {
        ...state,
        maintenanceList: [...state.maintenanceList, action.data],
      };
    case UPDATE_MAINTENANCE:
      let m = state.maintenanceList.findIndex(
        (w) => w.assetMaintainaceId === action.data.assetMaintainaceId
      );

      return {
        ...state,
        maintenanceDetail: { ...state.maintenanceDetail, ...action.data },
        maintenanceList: state.maintenanceList,
      };
    case FETCH_MAINTENANCE_BY_ID:
      return {
        ...state,
        maintenanceDetail: { ...action.data[0] },
      };

    case CHANGE_MAINTENANCE_STATUS:
      let maintenance = state.maintenanceList.find(
        (m) => m.assetMaintainaceId === action.data.assetMaintainaceId
      );
      let status = state.statusList.find(
        (s) => s.statusId === action.data.statusId
      );
      maintenance.status = { ...status };
      return {
        ...state,
        maintenanceList: [...state.maintenanceList],
      };
    case ASSIGN_MANINTENANCE:
      let mainenanceAssign = state.maintenanceList.find(
        (m) => m.assetMaintainaceId === action.data.assetMaintainaceId
      );
      mainenanceAssign["assignedTo"] = mainenanceAssign.assignedTo
        ? [...mainenanceAssign.assignedTo, action.data.assignTo]
        : [action.data.assignTo];

      return {
        ...state,
        maintenanceList: [...state.maintenanceList],
      };
    case DELETE_MAINTENANCE:
      return {
        ...state,
        maintenanceList: state.maintenanceList.filter(
          (m) => m.assetMaintainaceId !== action.data.assetMaintainaceId
        ),
      };
    case ADD_COMMENT:
      return {
        ...state,
        maintenanceDetail: { ...state.maintenanceDetail, comment: action.data },
      };
    case DELETE_ASSET_CHECKLIST:
      return {
        ...state,
        maintenanceDetail: {
          ...state.maintenanceDetail,
          checklist: state.maintenanceDetail.checklist.filter(
            (c) => c.checklistId !== action.data.checklistId
          ),
        },
      };
    case MARK_CHECKLIST_COMPLETE:
      let index = state.maintenanceDetail.checklist.findIndex(
        (c) => c.checklistId === action.data.checklistId
      );
      if (index) state.maintenanceDetail.checklist[index].isCompleted = true;
      return {
        ...state,
        maintenanceDetail: {
          ...state.maintenanceDetail,
        },
      };
    case DELETE_PO:
      return {
        ...state,
        maintenanceDetail: {
          ...state.maintenanceDetail,
          purchasing: state.maintenanceDetail.purchasing.filter(
            (p) => p.orderId !== action.data.poId
          ),
        },
      };
    case FETCH_WORK_ORDERS:
      return {
        ...state,
        workOrders: action.data.data,
        workOrderCount: action.data.totalCount,
      };
    case ADD_WORK_ORDERS:
      return {
        ...state,
        workOrders: [action.data, ...state.workOrders],
      };
    case UPDATE_WORK_ORDER:
      let workIndex = state.workOrders.findIndex(
        (a) => a.workId === action.data.workId
      );
      state.workOrders[workIndex] = { ...action.data };

      return {
        ...state,
        workOrders: [...state.workOrders],
      };

    case "FETCH_NEXT_WORKID":
      return {
        ...state,
        nextWorkIdRes: action.data,
      };

    default:
      return { ...state };
  }
};

export default maintenanceReducer;
